<bnd-button
  [color]="buttonColor()"
  [mode]="mode()"
  [size]="buttonSize()"
  aria-label="Note"
  [shape]="shape()"
  (click)="openNoteDialog()"
>
  <i
    class="pi"
    [class]="iconClass() + ' ' + iconName"
    [style.width.px]="iconWidth()"
    [style.fontSize.px]="fontSize()"
    [style.height.px]="iconHeight()"
    [class.text-primary]="noteFormControl()?.value || noteValue()"
  ></i>
</bnd-button>

<ao-note-dialog
  [open]="isNoteModalOpen()"
  [data]="noteDialogData"
  (result)="onNoteDialogResult($event)"
/>
